import Page from "@subly/s1/ui/base/Page";

import { WelcomeStep } from "core/models/welcome";
import { useWelcome } from "../fabric";

import Steps from "../components/Steps";
import Branding from "../components/Branding";
import System from "../components/System";
import Pricing from "../components/Pricing";
import Integration from "../components/Integration";
import Done from "../components/Done";


const StepContent = () => {
	const { step } = useWelcome();

	switch (step){
		case WelcomeStep.One: return <Branding />;
		case WelcomeStep.Two: return <System />;
		case WelcomeStep.Three: return <Pricing />;
		case WelcomeStep.Four: return <Integration />;
		case WelcomeStep.Done: return <Done />;
	}
};

export default function Welcome() {
	const { copy } = useWelcome();

	const style = {
		root: {
			justifyContent: "flex-start",
			alignItems: "center",
			gap: 2
		}

	} satisfies SxProps;

	return (
		<Page maxWidth="md" sx={style.root}>
			<Steps />
			<Page.Header title={copy.title} subtitle={copy.subtitle} />
			<Page.Body>
				<StepContent />
			</Page.Body>
		</Page>
	);
}